import React from "react";
import { CARD_STYLE_LARGE } from "../constants/styles";

export default function ChartCard({ title, children, onClick }) {

  const chartCard = {
    position: "relative", // 👈 KEY: allows absolute positioning inside
    display: "flex",
    width: "100%",
    height: "calc(100% - 20px)",
    //borderRadius: "12px",
    overflow: "visible",
    ...CARD_STYLE_LARGE,
	paddingTop:'20px',
	flexDirection:'column'
  };

  const chartBody = {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
	flexDirection:'column'
  };

  const overlayTitle = {
    position: "absolute",
    top: "10px",
    left: "50%",
    transform: "translateX(-50%)",

    padding: "8px 12px",
    borderRadius: "14px",

    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.3px",

    color: "#111827",

    background: "rgba(255,255,255,0.75)", // 👈 soft glass
    backdropFilter: "blur(6px)",

    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",

    pointerEvents: "none" // 👈 prevents blocking chart interaction
  };
  
  const handleClick = () => {
	if(onClick){
		onClick();
	}
  }

  return (
    <div style={chartCard} onClick={handleClick}>
      
      <div style={overlayTitle}>
        {title}
      </div>

      <div style={chartBody}>
        {children}
      </div>

    </div>
  );
}